import React, { useEffect } from "react";
import xlsx from "json-as-xlsx";
import { Button } from "react-bootstrap";
import moment from "moment";

function DownloadData({ exotelData, exotelStats, downloadData, statsData }) {
  const handleClick = () => {
    if (downloadData === "stats") {
      const _data = exotelStats?.map((item) => {
        return {
          agent: item?.agent,
          level: item?.level,
          name: item?.name,
          agent_id: item?.agent_id,
          time: item?.time,
          answered: item?.answered,
          attempts: item?.attempts,
          duration: item?.duration,
        };
      });

      const data = [
        {
          sheet: "Exotel Stats Data",
          columns: [
            { label: "agent", value: "agent" },
            { label: "level", value: "level" || "-" },
            { label: "name", value: "name" },
            { label: "agent_id", value: "agent_id" },
            { label: "time", value: "time" },
            { label: "answered", value: "answered" },
            { label: "attempts", value: "attempts" },
            { label: "duration", value: "duration" },
          ],
          content: _data,
        },
      ];
      let settings = {
        fileName: "Exotel Stats Data",
        extraLength: 3,
        writeMode: "writeFile",
        writeOptions: {},
      };

      xlsx(data, settings);
    } else if (downloadData === "data") {
      const _data = exotelData?.map((item) => {
        return {
          id: item?.id,
          call_id: item?.call_id,
          customer_number: item?.customer_number,
          agent_number: item?.agent_number,
          call_duration: item?.call_duration,
          call_recording: item?.call_recording,
          start_time: moment(item?.start_time, "YYYY/MM/DD HH:mm:ss").format(
            "DD/MM/YYYY HH:mm:ss"
          ),
          meta: item?.meta,
          engagement_id: item?.engagement_id,
          case_id: item?.case_id,
          rep_id: item.rep_id,
          created_at: moment(item?.created_at, "YYYY/MM/DD HH:mm:ss").format(
            "DD/MM/YYYY HH:mm:ss"
          ),
          updated_at: moment(item?.updated_at, "YYYY/MM/DD HH:mm:ss").format(
            "DD/MM/YYYY HH:mm:ss"
          ),
          exotel_sid: item?.exotel_sid,
          agent_name: item?.agent_name,
          level: item?.level,
          tag: item?.tag,
          customer: item?.customer,
        };
      });

      const data = [
        {
          sheet: "Exotel Data",
          columns: [
            { label: "id", value: "id" },
            { label: "call_id", value: "call_id" || "-" },
            { label: "customer_number", value: "customer_number" },
            { label: "agent_number", value: "agent_number" },
            { label: "call_duration", value: "call_duration" },
            { label: "call_recording", value: "call_recording" },
            { label: "start_time", value: "start_time" },
            { label: "meta", value: "meta" },
            { label: "engagement_id", value: "engagement_id" },
            { label: "case_id", value: "case_id" },
            { label: "rep_id", value: "rep_id" },
            { label: "created_at", value: "created_at" },
            { label: "updated_at", value: "updated_at" },
            { label: "exotel_sid", value: "exotel_sid" },
            { label: "agent_name", value: "agent_name" },
            { label: "level", value: "level" },
            { label: "tag", value: "tag" },
            { label: "customer", value: "customer" },
          ],
          content: _data,
        },
      ];

      let settings = {
        fileName: "Exotel Data",
        extraLength: 3,
        writeMode: "writeFile",
        writeOptions: {},
      };

      xlsx(data, settings);
    }
    // setDownloadSign(false);
  };

  return (
    <div>
      <Button className="btn btn-primary" onClick={handleClick}>
        Download
      </Button>
    </div>
  );
}

export default DownloadData;
